export default "__VITE_ASSET__Bcp53Nei__"